export default {
	SET_LANGUAGE_PAIRS: "SET_LANGUAGE_PAIRS",
	CREATE_LANGUAGE_PAIR: "CREATE_LANGUAGE_PAIR",
	SET_LOADING: "SET_LOADING",
	REMOVE_LANGUAGE_PAIR: "REMOVE_LANGUAGE_PAIR"
}